<script>
    export let text = '';
    export let noMargin = false;
</script>

<h2 class="{$$props.class || 'h3'} transition-all ease-in-out duration-150 font-semibold {noMargin ? '' : 'mb-5'}">{text}</h2>
